"use strict";

class NavChange {
  constructor() {
    this.init();

    window.addEventListener("scroll", () => {
      this.init();
    });
  }

  init() {
    const navChange = Array.prototype.slice.call(document.getElementsByClassName("js-block-light"));
    const header = document.querySelector("#header");
    for (const elem of navChange) {
      header.classList.remove("-black");

      if (this.isVisible(elem)) {
        header.classList.add("-black");
        return;
      }
    }
  }

  isVisible(node) {
    const top = node.getBoundingClientRect().top;
    const bottom = node.getBoundingClientRect().bottom;
    return top < 0 && bottom > 0;
  }
}

export default NavChange;
